export function getPrintCSS() {
    return `
        :root {
            --base-width: 6.5mm;
            --info-width: 8mm;
            --desc-width: 23.5mm;
        }

        * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
            border: 0;    
        }

        body {
            font-size: 6pt;
        }

        .oddsTable {
            margin: 4.5mm 6.5mm;
            page-break-before: always;
        }

        .header-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .customerLogo {
            height: 6mm;
        }

        .table-body {
            display: grid;
        }

        .headerPrincipale, .subHeader {
            font-weight: bold;
        }

        .headerPrincipale, .subHeader, .rigaValorizzata {
            display: grid;
            grid-auto-rows: auto;
        }

        .info, .event {
            grid-row: 1 / 3;
            align-content: center;
        }

        .event, .subHeader .team {
            text-transform: uppercase;
        }

        .rigaOrario {
            display: grid;
        }

        .cell {
            align-content: center;
            text-align: center;
            border-right: 0.25mm solid #000;
            border-bottom: 0.25mm solid #000;
        }
        
        // .headerPrincipale .cell {
        //     white-space: nowrap;
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        // }

        .cell.date {
            text-align: left;
            text-align: left;
        }
        
        .cell:first-child {
            border-left: 0.25mm solid #000;
        }

        .headerPrincipale .info.cell,
        .headerPrincipale .event.cell,
        .headerDescScomm.cell {
            border-top: 0.75mm solid #000;
        }

        .headerPrincipale .cell, .subHeader .cell {
            border-width: 0.75mm;
        }

        .subHeader .cell {
            font-size: 5pt;
        }

        .rigaOrario .cell {
            border: none;
            font-weight: bold;
            font-size: 7pt;
        }

        .rigaOrario > .cell {
            border-bottom: 0.25mm solid #000;
        }
    `;
}
